import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Error from '../../common/Error';
import EditRegion from '../../common/EditRegion';


import { useSessionContext } from '../../../contexts/SessionContext';


export default function NamedLocationsEditLookup(props) {
    //console.debug("RTS Break NamedLocationsEditLookup");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [hasError, setHasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");

    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [region, setRegion] = useState('');
    const [zip, setZip] = useState('');


    function handleSubmit(e) {
        e.preventDefault();

        let returnVal = {
                address:null,
                address2:null,
                city:null,
                region:null,
                zip:null,
                lat:null,
                lng:null
            }

        let query = address1 + ' ' + address2 + ' ' + city + ' ' + region + ' ' + zip;
        let accessToken = 'pk.eyJ1IjoiamltcHRhayIsImEiOiJja3kzMXZyOHIwNnRvMnBwOGxrbWJ4ZDhiIn0.bWHzm3g7ZOvo1wcWf2w8fg';
        let apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${accessToken}`;

        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
            )
        .then(response => {

            if(response.data){
                if(response.data.features && response.data.features.length > 0){
                    let features = response.data.features[0];


                    if(features.place_type){
                        let placeType = features.place_type[0];

                        if(placeType === 'address'){
                            if(features.place_name){
                                let parts = features.place_name.split(',');

                                returnVal.address = parts[0];
                                returnVal.city = parts[1];

                                let numIdx = parts[2].search(/\d/);
                                returnVal.region = parts[2].substring(1, numIdx).trim();
                                returnVal.zip = parts[2].substring(numIdx);
                            }
                        }
                    }

                    if(features.center){
                        returnVal.lat = features.center[0];
                        returnVal.lng = features.center[1];
                    }

                    props.setSearchDataFx(returnVal);
                }
            }
        })
        .catch(error => {
            props.updateCurDataFx(1);
            setErrorBody("An error has occured.  Please review the console log for details.");
            console.log("RTS UpdateCustomerReel Error", error);
            setShowErrorModal(true);
        });
    }


    if(hasError){
        return(
            <Error />
        );
    };
    
    
    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Box>
            <form id="locationLookupForm" onSubmit={handleSubmit}>
                <Typography variant="h6" sx={{mt:2, mb:2}}>Address</Typography>
                <TextField
                    id="tbAddress1"
                    margin="none"
                    fullWidth
                    label="Street Address"
                    size="small"
                    value={address1}
                    onChange={(e) => {setAddress1(e.target.value);}}
                />
                <TextField
                    id="tbAddress2"
                    margin="dense"
                    fullWidth
                    size="small"
                    value={address2}
                    onChange={(e) => {setAddress2(e.target.value);}}
                />
                <TextField
                    id="tbCity"
                    margin="normal"
                    fullWidth
                    label="City"
                    size="small"
                    value={city}
                    onChange={(e) => {setCity(e.target.value);}}
                />
                <Grid container>
                    <Grid item xs={6} sx={{pr:1}}>
                        <EditRegion region={region} setRegionFx={setRegion} />
                    </Grid>
                    <Grid item xs={6} sx={{pl:1}}>
                        <TextField
                            id="tbZip"
                            margin="normal"
                            fullWidth
                            label="Zip Code"
                            size="small"
                            value={zip}
                            onChange={(e) => {setZip(e.target.value);}}
                        />
                    </Grid>
                </Grid>
                <Box sx={{textAlign:'right', mt:2}}>
                    <Button variant="contained" type="submit" sx={{mr:2}}>Search</Button>
                    <Button variant="contained" type="button" onClick={() => {props.setShowLookupModalFx(false);}}>Cancel</Button>
                </Box>
            </form>
        </Box>
        </>
    );
}